import vacancyService from "@/services/vacancy.service";


const state = {
    testListTotal: 0,
    testList: [],
    randomTestList: {},
    start: 0,
    end: 1,
    selectedDepsId: ''
};

const getters = {
    startGetter: (state) => {
        return state.start
    },
    endGetter: (state) => {
        return state.end
    },
}
const actions = {
    async getTestList({ commit }, data) {
        try {
            let res = await vacancyService.getTestList(data)
            await commit('setTestList', res.data ? res.data : [])
        } catch (e) {
            await commit('setTestList', [])
        }
    },

    async getRandomQuestion({ commit }) {
        try {
            let res = await vacancyService.getRandomTestList()
            await commit('setRandomTestList', res.data ? res.data : [])
        } catch (e) {
            await commit('setRandomTestList', [])
        }
    },
}


const mutations = {
    setTestList(state, data) {
        state.testList = data.list
        state.testListTotal = data.total
    },
    setRandomTestList(state, data) {
        state.randomTestList = data
    },
    setPage(state, data) {
        state.start = data
        state.end = parseFloat(data) + 1
    },
    next(state) {
        if (state.end < 30) {
            state.start = parseFloat(state.start) +1 
            state.end = parseFloat(state.end)+1
        }
    },
    prev(state) {
        if (state.end > 1) {
            state.start = parseFloat(state.start) -1
            state.end = parseFloat(state.end)-1
         
        }
    },
    
    setSelectedDepsId(state, id) {
        state.selectedDepsId = id
    },
}

export const testcrud = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
